import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'ts-terms-and-conditions-dialog',
    templateUrl: './terms-and-conditions-dialog.component.html',
    styleUrls: ['./terms-and-conditions-dialog.component.scss'],
    standalone: false
})
export class TermsAndConditionsDialogComponent {}

@NgModule({
  imports: [CommonModule, MatDialogModule, TranslateModule],
  declarations: [TermsAndConditionsDialogComponent],
})
export class TermsAndConditionsDialogModule {}
